import { X } from "lucide-react";
import { ChatContact } from "../../../utils/types";
import ChatAvatar from "./chatAvatar";

interface ChatMessageToastProps {
  peer: ChatContact;
  preview: string;
  isVisible: boolean;
  onOpen: () => void;
  onDismiss: () => void;
}

const ChatMessageToast = ({ peer, preview, isVisible, onOpen, onDismiss }: ChatMessageToastProps) => (
  <div
    className={`flex w-88 max-w-[calc(100vw-2rem)] items-stretch overflow-hidden rounded-2xl border border-(--brand-primary)/35 bg-(--app-raised) shadow-2xl shadow-black/60 transition-all duration-200 ${
      isVisible ? "translate-y-0 opacity-100" : "-translate-y-2 opacity-0"
    }`}
  >
    <button
      type="button"
      onClick={onOpen}
      className="flex min-w-0 flex-1 items-center gap-3 px-4 py-3 text-left transition-colors hover:bg-white/5"
    >
      <ChatAvatar name={peer.name} imageUrl={peer.imageUrl} isOnline={peer.isOnline} />
      <span className="min-w-0 flex-1">
        <span className="block text-[10px] font-semibold tracking-wider text-(--brand-primary) uppercase">
          New message
        </span>
        <span className="block truncate text-sm font-semibold text-white">{peer.name}</span>
        <span className="line-clamp-2 text-xs wrap-break-word text-white/70">{preview}</span>
      </span>
    </button>
    <button
      type="button"
      onClick={onDismiss}
      aria-label="Dismiss"
      className="border-l border-white/10 px-3 text-white/60 transition-colors hover:bg-white/5 hover:text-white"
    >
      <X size={16} />
    </button>
  </div>
);

export default ChatMessageToast;
